// Minnesotaänger Mini App — floating action buttons.
// Trimmed from telegram-tt: unread-mention/reaction/poll buttons and the
// thread read state were removed (v1 has no such counts); only the
// scroll-down button remains, keeping the baseline
// FloatingActionButtons.module.scss positioning (floats above the
// composer footer, hidden until `revealed`).

import { memo } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';

import ScrollDownButton from './ScrollDownButton';

import styles from './FloatingActionButtons.module.scss';

type OwnProps = {
  withScrollDown: boolean;
  onClick: VoidFunction;
};

const FloatingActionButtons = ({ withScrollDown, onClick }: OwnProps) => {
  const fabClassName = buildClassName(
    styles.root,
    withScrollDown && styles.revealed,
  );

  return (
    <div className={fabClassName}>
      <ScrollDownButton
        icon="arrow-down"
        ariaLabel="滚动到底部"
        onClick={onClick}
        className={styles.unread}
      />
    </div>
  );
};

export default memo(FloatingActionButtons);
